module.exports = __webpack_public_path__ + "static/media/spaceCrxillion0.c555583c.png";